import {AnnotationsConstants} from "../../../utils/const";
import CreateIcon from "@mui/icons-material/Create";
import React from "react";
import BaseDrawTool from "./BaseDrawTool";
import {getFormattedLength, getUperpixel} from "../../../utils/utils";
import LineDistanceMeasureOverlay from "./overlays/LineDistanceMeasureOverlay";
import LineAngleMeasureOverlay from "./overlays/LineAngleMeasureOverlay";
import cookie from "react-cookies";

class FreeLine extends BaseDrawTool {

	id = "Freeline";
	name = "Freeline";
	type = "LineString";
	shape = AnnotationsConstants.LINE;
	icon = <CreateIcon/>;
	freehand = true;
	className = "FreeLine-forTour"
	shortcutKey = "2";

	init() {
		super.init();
		this.distanceOverlay = new LineDistanceMeasureOverlay(this.props.slidemap, this.props.slide.uperpixel);
		this.angleOverlay = new LineAngleMeasureOverlay(this.props.slidemap, this.props.slide.uperpixel);
	}

    getArea = () => 0;

    getPerimeter = (geometry) => geometry.getLength();

    getGeometricParams = (geometry) => ({
        area: 0,
        perimeter: geometry.getLength() * getUperpixel(),
        coordinates: geometry.getCoordinates(),
    });

    getTitle = (feature) => {
        let suffix = cookie.loadAll().superuser === 'true' ? 'A ' : 'R ';
        return suffix + `${getFormattedLength(this.getGeometricParams(feature.getGeometry()).perimeter)}`;
    }

    onDrawStart = (event) => {
        event.feature.getGeometry().on('change', this.distanceOverlay.onGeometryChange);
        this.angleOverlay.setLayer(this.props.layer);
        event.feature.getGeometry().on('change', this.angleOverlay.onGeometryChange);
    }

    onDrawEnd = (event) => {
        this.addFeatureAnnotation(event.feature);
        this.distanceOverlay.close();
		this.angleOverlay.close();
	}
}

export default FreeLine;
